<template>
    <div class="role-org-item-list">
        <ul>
            <v-tag v-for="(role, index) in value" :key="role.id"
                class="role-org-item-tag"
                use-default-suf-icon
                :text="role.name"
                size="large"
                :pre-icon="role.iconArr"
                icon-fixed
                @sufAction="deleteRole(index)"
            />
        </ul>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';

const req = require.context('./assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
    props: {
        value: {
            type: Array,
            default() {
                return [];
            },
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            defaultDisabled: this.disabled,
        };
    },
    mounted() {
        // this.updateValue();
    },
    methods: {
        deleteRole(i) {
            const newVal = this.value.splice(i, 1);
            this.$emit('change', newVal);
        },
    },
};
</script>
<style lang="less">
@import './index.less';
</style>
